import { render, staticRenderFns } from "./producto_crud.vue?vue&type=template&id=02e87daa&scoped=true"
import script from "./producto_crud.vue?vue&type=script&lang=js"
export * from "./producto_crud.vue?vue&type=script&lang=js"
import style0 from "./producto_crud.vue?vue&type=style&index=0&id=02e87daa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e87daa",
  null
  
)

export default component.exports